export const PerformanceService = {
  get(name, type) {
    let fn;

    if (['mark', 'measure'].includes(type)) {
      fn = global.performance.getEntriesByType.bind(global.performance, type);
    } else {
      fn = global.performance.getEntries.bind(global.performance);
    }

    const regex = new RegExp(`${name.replace('[', '\\[')}(?:\\[(\\d+)])?`);

    return fn().filter(({ name: perfName }) => regex.test(perfName));
  },

  getLatest(name, type) {
    const entries = this.get(name, type);
    return entries[entries.length - 1];
  },

  getLatestMark(name) {
    return this.getLatest(name, 'mark');
  },

  getLatestMeasure(name) {
    return this.getLatest(name, 'measure');
  },

  getMark(name) {
    return this.get(name, 'mark')[0];
  },

  getMeasure(name) {
    return this.get(name, 'measure')[0];
  },

  mark(name) {
    const entries = this.get(name, 'mark');
    const regex = new RegExp(`${name}\\[(\\d+)]`);

    const highestIndex = entries.reduce((acc, { name: perfName }) => {
      const matches = regex.exec(perfName);
      if (matches) {
        const matchedIndex = Number(matches[1]);
        if (matchedIndex > acc) {
          return matchedIndex;
        }
      }

      return acc;
    }, -1);

    global.performance.mark(`${name}[${highestIndex + 1}]`);

    return this.getLatestMark(name);
  },

  measure(name, startMark, endMark) {
    let _startMark = startMark?.name ?? startMark;
    let _endMark = endMark?.name ?? endMark;

    const end = () => {
      _endMark = this.mark(`${name}_END`);

      global.performance.measure(name, _startMark.name, _endMark.name);
    };

    const start = () => {
      _startMark = this.mark(`${name}_START`);

      return end;
    };

    if (!_startMark && !_endMark) {
      return start;
    }

    global.performance.measure(name, _startMark, _endMark);

    return this.getLatestMeasure(name);
  },
};
